import React, {useEffect, useState} from "react"
import {useLocal, useModal, useRoomSetup, useSolution} from "../../AppContext"
import {Button, ButtonText} from "../../Components/Button"
import {useTipCounter} from "../../Hooks/TipCounter"
import style from "./ViewLoading.css"
import {Line} from 'rc-progress'
import {iconInfo, iconArrowToLeft, iconArrowToRight, iconCheckmark} from "../../Helper/Icons"
import {progressBar} from "../../settings"
import viewLoadingTips from "./ViewLoadingTips"

export const ViewLoading = ({suggestedSolutions}) => {
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const tipCounter = useTipCounter()

    const imageStyle = {backgroundImage: `url(${tipCounter.getImage()})`}

    useEffect(() => {
        suggestedSolutions.load(roomSetup.getId(), local.getLang(true))
    }, [])

    return <>
        <div className={style.main} style={imageStyle}>
            <div>
                <LoadingInformation/>
                <Error suggestedSolutions={suggestedSolutions}/>
                <ProgressBar suggestedSolutions={suggestedSolutions}/>
                <Tips tipCounter={tipCounter}/>
            </div>
        </div>
        <Footer suggestedSolutions={suggestedSolutions}/>
    </>
}

const LoadingInformation = () => {
    const local = useLocal()
    return <div className={style.loadingInformation}>
        {iconInfo}
        <div dangerouslySetInnerHTML={{__html: local.__("Bei großen Räumen kann die Berechnung der Sets für die 3D-Ansicht bis zu einer Minute dauern. Lehnen Sie ich einfach zurück - es lohnt sich!")}}/>
    </div>
}

const ProgressBar = ({suggestedSolutions}) => {
    const local = useLocal()
    const colorOrange = getComputedStyle(document.documentElement).getPropertyValue('--color-orange');
    
    const [currentProgressNumber, setCurrentProgressNumber] = useState(0)
    const isLoading = suggestedSolutions.isLoading()
    const hasError = suggestedSolutions.hasError()
    
    useEffect(() => {
        const completeProgressNumber = 100
        const {countProcessingSteps: steps, averageProcessingDuration: averageProcessingTime}= progressBar
        let intervalId = null
        const intervalDuration = averageProcessingTime/steps
        intervalId = setInterval(() => {
            if (currentProgressNumber >= completeProgressNumber) {
                clearInterval(intervalId)
            }
            const progressNumber = completeProgressNumber/steps
            if (!isLoading) {
                setCurrentProgressNumber(completeProgressNumber)
                clearInterval(intervalId)
            } else {
                setCurrentProgressNumber(prevNumber => prevNumber + progressNumber)
            }
        }, intervalDuration)
        return () => {
            clearInterval(intervalId)
        }
    }, [currentProgressNumber])

    if (hasError) {
        return null
    }
    
    return <div className={style.buildProgress}>
        <div className={style.container}>
            <div className={style.title}>
                {isLoading ? local.__("Ihr Raum wird gebaut!") : local.__("Ihr Raum ist bereit!")}
            </div>
            {isLoading && <div className={style.bar}>
                <Line percent={currentProgressNumber} strokeWidth={4} strokeColor={colorOrange} trailColor="#FFFFFF" trailWidth={4}/>
            </div>}
            {!isLoading && <div className={style.iconReady}>{iconCheckmark}</div>}
        </div>
    </div>
}

const Error = ({suggestedSolutions}) => {
    return suggestedSolutions.hasError() ? <div className={style.error}>{suggestedSolutions.getError()}</div> : null
}

const Tips = ({tipCounter}) => {
    const local = useLocal()
    return <div className={style.tips}>
        <div className={style.item}>
            <div className={style.title}>
                <div className={style.icon}><div><span>{local.__("Tipp")}</span></div></div>
                <div className={style.name}>{local.__(tipCounter.getName())}</div>
            </div>
            <div className={style.content}>
                <ButtonText onClick={tipCounter.previousItem}>{iconArrowToLeft}</ButtonText>
                <div className={style.description}>{local.__(tipCounter.getDescription())}</div>
                <ButtonText onClick={tipCounter.nextItem}>{iconArrowToRight}</ButtonText>
            </div>
        </div>
        <div className={style.step}>
            {viewLoadingTips.map((item, index) => {
                if (tipCounter.getCurrentIndex() === index) {
                    return <div className={style.active} key={index}/>    
                } else {
                    return <div key={index}/>
                }
            })}
        </div>
    </div>
}

const Footer = ({suggestedSolutions}) => {
    const local = useLocal()
    const modal = useModal()
    const solution = useSolution()

    const onApply = () => {
        
        modal.close()
        const addPlanningTo3D = async () => {
            const solutions = suggestedSolutions.getSolutions()
            for(let i = 0 ; i < solutions.length; i++) {
                const products = solutions[i].products
                const name = local.getLabel(solutions[i].name)
                await solution.addPlanning(products, name)
            }
        }
        addPlanningTo3D()
        
    }

    return <div className={style.footer}>
        <div>
            <ButtonText onClick={suggestedSolutions.stepBack}>{local.__("Zurück")}</ButtonText>
        </div>
        <div>
            <Button isDisabled={!suggestedSolutions.hasSolutions()} onClick={onApply}>{local.__("Weiter")}</Button>
        </div>
    </div>
}
